<template>
  <div class="browse-vehicles-background-component hero-banners-with-dropdown-search-component compliant-banners" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="carousel slide" data-interval="5000" data-ride="carousel" id="compliantBannerCarouselWithDropdownSearch">
      <ol class="carousel-indicators">
        <li class="active" data-slide-to="0" data-target="#compliantBannerCarouselWithDropdownSearch">
          <div class="inner-circle"></div>
        </li>
        <li data-slide-to="1" data-target="#compliantBannerCarouselWithDropdownSearch" class="">
          <div class="inner-circle"></div>
        </li>
        <li data-slide-to="2" data-target="#compliantBannerCarouselWithDropdownSearch" class="">
          <div class="inner-circle"></div>
        </li>
        <li data-slide-to="3" data-target="#compliantBannerCarouselWithDropdownSearch" class="">
          <div class="inner-circle"></div>
        </li>
      </ol>
      <div class="carousel-inner" v-if="images.homeBanners.length > 0">
        <div class="item" v-for="(banner, index) in images.homeBanners" :key="index" :class="[index === 0 ? activeClass: '']">
          <img :src="banner">
        </div>
      </div>
      <a class="left carousel-control" data-slide="prev" href="#compliantBannerCarouselWithDropdownSearch">
        <img alt="Previous" class="carousel-chevron chevron-left chevron-dark reviews-chevron" src="../../static/images/common-icons/left-arrow-white.png">
      </a>
      <a class="right carousel-control" data-slide="next" href="#compliantBannerCarouselWithDropdownSearch">
        <img alt="Next" class="carousel-chevron chevron-right chevron-dark reviews-chevron" src="../../static/images/common-icons/right-arrow-white.png">
      </a>
    </div>
    <div class="browse-overflow">
      <div class="browse-vehicles">
        <div class="container">
          <div class="vehicle-browse-ajax">
            <form action="/vehicles" class="vehicle-search-form" method="get">
              <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-type">Select vehicle type:</label>
                <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search search-inv-type" id="dropdown-vehicle-type" name="type">
                  <option data="true" value="new">New</option>
                  <option data="false" value="used">Used</option>
                </select>
                <i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-year">Select vehicle year:</label>
                <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-year" id="dropdown-vehicle-year" name="year">
                  <option value="default">Any Year</option>
                </select>
                <i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-make">Select vehicle make:</label>
                <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-make" id="dropdown-vehicle-make" name="make">
                  <option value="make">{{ brandName }}</option>
                </select>
                <i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-model">Select vehicle model:</label>
                <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-model" id="dropdown-vehicle-model" name="model">
                  <option value="default">Any Model</option>
                </select>
                <i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group" id="search-submit">
                <input aria-label="Click here to submit" class="btn search-form-btn vehicle-search-submit" value="Search">
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ['component', 'images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active'
    }
  },
  computed: {
    ...mapGetters(["chosenArray"]),
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda' && this.brand !== 'cjdr') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else if (this.brand === 'cjdr') {
        return 'url(' + this.images.lifestyleImages.truckImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  },
  mounted() {
    (function() {
      
      var c = {
        init: function() {
          $('#compliantBannerCarouselWithDropdownSearch').carousel({
            interval: 5000
            })
        }
      }
      $(document).ready(c.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.visuallyhidden {
  display: none;
}
.hero-banners-with-dropdown-search-component .container {
  padding: 0 15px;
}
.hero-banners-with-dropdown-search-component .carousel .item img,
.hero-banners-with-dropdown-search-component .carousel .item {
  width: 100% !important;
}
.hero-banners-with-dropdown-search-component .browse-overflow {
  margin: -35px auto 0px !important;
  z-index: 8;
  padding-bottom: 30px;
  overflow: visible;
}
.hero-banners-with-dropdown-search-component .browse-overflow .container {
  padding: 0;
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax {
  width: 100%;
  max-width: 1024px;
  margin: auto auto 20px;
  padding: 15px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0px 0px 16px rgb(16 16 16 / 26%);
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax .form-group {
  flex: 0 0 20%;
  position: relative;
  margin-bottom: 0px;
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax .form-group:not(#search-submit) {
  background-color: #fff;
  line-height: 32px;
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax .form-group i {
  position: absolute;
  line-height: 40px;
  right: 12px;
  top: 0;
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax .form-control {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: 1;
  background-color: transparent;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  padding: 6px 12px 6px 0px;
  text-transform: uppercase;
  text-align: center;
  font-size: 13px;
  color: var(--primary-dark);
  font-family: var(--bold-text);
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
  background-color: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 3px;
  text-transform: uppercase;
  padding: 12px 0px;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.hero-banners-with-dropdown-search-component .vehicle-browse-ajax .search-form-btn.vehicle-search-submit:hover {
  opacity: .7;
}
.hero-banners-with-dropdown-search-component .carousel-indicators {
  bottom: 40px;
  margin-bottom: 0px;
}
.compliant-banners .carousel-indicators li {
  background: rgba(255,255,255,0);
  height: 14px;
  width: 14px;
  border-radius: 100%;
  padding: 3px;
  margin: 1px 5px 1px 1px;
  border: none;
}
.compliant-banners .carousel-indicators li .inner-circle {
  background: rgba(255,255,255,.8);
  height: 8px;
  width: 8px;
  border-radius: 100%;
}
.compliant-banners .carousel-indicators .active {
  background: rgba(255,255,255,0);
  border: 2px solid rgba(255,255,255,1);
}
.compliant-banners .carousel-indicators .active .inner-circle {
  background: rgba(255,255,255,0);
}
.compliant-banners .carousel-control.left,
.compliant-banners .carousel-control.right {
  background-image: none;
  width: 30px;
  -moz-transition: all 300ms ease-out;
  -webkit-transition: all 300ms ease-out;
  -o-transition: all 300ms ease-out;
  transition: all 300ms ease-out;
}
.compliant-banners .carousel-control img {
  position: absolute;
  top: calc(50% - 11px);
  z-index: 105;
  display: inline-block;
  height: 22px;
}
.compliant-banners .carousel-control.left img {
  left: 30px;
}
.compliant-banners .carousel-control.right img {
  right: 30px;
}

@media (min-width: 1462px) {
  .compliant-banners .banner-container {
    width: 1422px;
    max-width: 1422px;
    padding: 0px;
  }
}

@media (max-width: 991px) {
  .compliant-banners .carousel-control.left img {
    left: 15px;
  }
  .compliant-banners .carousel-control.right img {
    right: 15px;
  }
}

@media (max-width: 767px) {
  .compliant-banners .banner-container {
    width: 100%;
    padding: 0px;
  }
  .hero-banners-with-dropdown-search-component .carousel-indicators {
    bottom: 0px;
  }
}

@media (max-width: 991px) {
  .hero-banners-with-dropdown-search-component .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
    padding: 10px 0px;
  }
  .hero-banners-with-dropdown-search-component .vehicle-browse-ajax .form-group i {
    line-height: 37px;
  }
}

@media (min-width: 768px) {
  .hero-banners-with-dropdown-search-component .browse-row {
    padding: 0 15px;
  }
  .hero-banners-with-dropdown-search-component .search-row {
    padding: 0 30px;
  }
  .hero-banners-with-dropdown-search-component .vehicle-search-form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }
  .hero-banners-with-dropdown-search-component .vehicle-browse-ajax .form-group {
    flex-basis: 20%;
    max-width: 20%;
  }
  .hero-banners-with-dropdown-search-component .form-group:nth-of-type(1), 
  .hero-banners-with-dropdown-search-component .form-group:nth-of-type(2), 
  .hero-banners-with-dropdown-search-component .form-group:nth-of-type(3) {
    margin-right: 0px !important;
    border-right: 1px solid #d5d5d5;
  }
}

@media (max-width: 767px) {
  .hero-banners-with-dropdown-search-component .form-group {
    margin: 0 auto;
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .hero-banners-with-dropdown-search-component .form-group:nth-of-type(1), 
  .hero-banners-with-dropdown-search-component .form-group:nth-of-type(2), 
  .hero-banners-with-dropdown-search-component .form-group:nth-of-type(3) {
    border-bottom: solid 1px #d5d5d5;
  }
  .hero-banners-with-dropdown-search-component .form-group .form-control {
    padding: 6px 20px 6px 12px;
    text-align: left;
  }
  .hero-banners-with-dropdown-search-component .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
    padding: 15px 0px;
    margin-top: 30px;
  }
  .hero-banners-with-dropdown-search-component .form-group i {
    position: absolute;
    right: 12px;
    top: 0px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hero-banners-with-dropdown-search-component .browse-overflow {
    margin: 0 auto !important;
  }
  .hero-banners-with-dropdown-search-component .browse-overflow .vehicle-browse-ajax {
    padding-top: 10px;
    width: 100%;
    max-width: none;
    position: static;
    -ms-transform: none;
    -webkit-transform: none;
    transform: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
}

.hero-banners-with-dropdown-search-component[data-brand="mazda"] .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
  letter-spacing: 2px;
}
</style>
